import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles(() => ({
    block: {
      padding: '9px 20px',
      borderRadius: '4px',
      border: '1px solid #cfd8dc',
      width: '470px',
      margin: '10px',
      '& button': {
        color: '#006cfc',
      },
    },
    hl: {
      position: 'absolute',
      width: '3%',
      marginTop: '10%',
      left: -10,
      borderTop: '2px dashed #b0bec5',
    },
    vl: {
      borderRight: '2px dashed #b0bec5',
      height: '100%',
      position: 'absolute',
      left: '-7px',
      marginLeft: '-6px',
      marginTop: '-11px',
    },
    vlChild: { height: '49px' },
    titleParam: {
      textTransform: 'none',
      direction: 'rtl',
      '& .type': {
        fontSize: '12px',
        color: '#78909c',
      },
    },
  }));